import authRules from '../authRules.js';

const isApprover = (user) => {
  const { status } = user.securityLevels;
  if (status >= authRules.isApprover.status) {
      return true;
  } else {
      return false;
    }
  }


export default isApprover;
